import React, { PropsWithChildren } from 'react'
import classes from './Table.module.scss'

export type BodyProps = PropsWithChildren<{
  height?: string
  maxHeight?: string
}>

const Body = ({ height, maxHeight, children }: BodyProps) => {
  const style = { height, maxHeight }

  return (
    <div className={classes.body} style={style}>
      {children}
    </div>
  )
}

export default Body
